module.exports = __webpack_public_path__ + "img/logo-app.3dd086b6.svg";